# Approval Card

A binary decision surface for approve/reject workflows.

## Install

```bash
npx aiapp-ui add approval-card
```

## Usage

```tsx
import { ApprovalCard } from "@/components/aiapp-ui/approval-card";

<ApprovalCard
  title="Deploy to production"
  description="Release v2.4.1 to all regions. This will affect 12,000 active users."
  actions={[
    { id: "approve", label: "Approve", variant: "primary" },
    { id: "reject", label: "Reject", variant: "destructive" },
  ]}
  onAction={(actionId) => console.log(actionId)}
/>;
```

**Role**: Decision. For binary choices where the outcome matters. See [Design Guidelines](/docs/design-guidelines) for how component roles work.

## Props

| Prop          | Type                         | Description                                    |
| ------------- | ---------------------------- | ---------------------------------------------- |
| `title`       | `string`                     | The action being approved                      |
| `description` | `string`                     | Context for the decision                       |
| `actions`     | `Action[]`                   | Available actions (typically approve/reject)   |
| `choice`      | `Choice`                     | Receipt state -- renders as a one-line summary |
| `onAction`    | `(actionId: string) => void` | Called when the user clicks an action          |

## Receipt state

Pass a `choice` prop to render the receipt:

```tsx
<ApprovalCard
  title="Deploy to production"
  choice={{ decision: "approved", timestamp: "2026-03-08T10:00:00Z" }}
/>
```

Renders: **Approved**: Deploy to production

## Accessibility

- Action buttons are focusable and keyboard-activatable
- Destructive actions have appropriate ARIA labels
- Receipt state is announced to screen readers
